import AOS from 'aos';
import 'aos/src/sass/aos.scss';

import '../scss/main.scss';
import './app/slides';
import './app/accordion';
import './app/nav';
import './app/menu_nav';
import './app/location';
import './app/search';
import './app/sidebar';
import './app/range';
import './app/form';
import './app/filter';
import './app/category';
import './app/mask';
import './app/orders';


AOS.init({
    once: true,
    duration: 500,
});